import { useTranslation } from 'react-i18next';
import { formatAssetNetworkLabel } from '@shared/lib/asset-balance';
import { resolveNetworkIconSrc } from '@shared/lib/network-icons';
import { cn } from '@shared/lib/utils';

interface ReconciliationAssetCellProps {
  assetCode: string;
  networkCode: string;
  assetIconSrc?: string | null;
  className?: string;
}

/** Актив + сеть в одной колонке: иконка монеты, бейдж сети, подписи как в балансах/инвойсах. */
export function ReconciliationAssetCell({
  assetCode,
  networkCode,
  assetIconSrc,
  className,
}: ReconciliationAssetCellProps) {
  const { t } = useTranslation('cabinet');
  const networkIconSrc = resolveNetworkIconSrc(networkCode);
  const networkLabel = formatAssetNetworkLabel(networkCode, t('balance.historicalNetwork'));

  return (
    <div className={cn('flex min-w-0 items-center gap-2', className)}>
      <div className="relative shrink-0">
        {assetIconSrc ? (
          <img src={assetIconSrc} alt="" className="size-5 rounded-full sm:size-6" aria-hidden />
        ) : (
          <div className="size-5 rounded-full bg-muted sm:size-6" aria-hidden />
        )}
        {networkIconSrc ? (
          <img
            src={networkIconSrc}
            alt=""
            className="absolute -bottom-0.5 -right-0.5 size-3 rounded-full border border-background bg-background dark:invert sm:size-3.5"
            aria-hidden
          />
        ) : null}
      </div>
      <div className="min-w-0">
        <p className="truncate text-sm font-medium leading-tight text-foreground">{assetCode}</p>
        <p className="truncate text-xs text-muted-foreground">{networkLabel}</p>
      </div>
    </div>
  );
}
